import { connect } from 'react-redux'
import toJS from '../../../containers/general/toJS.js';
import DatePicker from "react-datepicker";
import Translation from '../../Translation/cont/Translation';

const mapStateToProps = state => ({
    translationChooseDate: state.getIn(['translation', 'strings', 'formik_datepicker_choose_date']),
    currentLang: state.getIn(['translation', 'currentLang']),
})

const DatePickerContainer =  ({
    name, 
    onChange,
    value,
    id,
    resetValue='',
    isStartDate=false,
    label,
    className,
    submitOnChange,
    start=false,
    end=false,
    translationChooseDate,
    currentLang
}) => {
    const today = new Date()
    const minDate = start ? new Date(start) : today
  
    return (
        <DatePicker
            selected={(value !== '' && new Date(value)) || null}
            onChange={val => {
                if(isStartDate && val > new Date(end)) {                
                    onChange(name, val);
                    onChange(resetValue, '');
                } else if(val === null) {
                    onChange(name, '');
                } else {
                    onChange(name, val);
                }

                if(submitOnChange) {
                    submitOnChange()
                }
            }}
            dateFormat="dd/MM/yyyy"
            locale={currentLang}
            todayButton={<Translation id="formik_datepicker_today"/>}
            isClearable
            showWeekNumbers
            minDate={minDate}
            placeholderText={translationChooseDate[currentLang]}
        />
    )
}

export default connect(mapStateToProps)(toJS(DatePickerContainer))